import {beautifulCookieConsent} from "./cmps/beautiful-cookie-consent.mjs"
import {complianz} from "./cmps/complianz.mjs"
import {cookieCompliance} from "./cmps/cookie-compliance.mjs"
import {cookieConfirm} from "./cmps/cookie-confirm.mjs"
import {cookieScript} from "./cmps/cookie-script.mjs"
import {cookiebot} from "./cmps/cookiebot.mjs"
import {cookiefirst} from "./cmps/cookiefirst.mjs"
import {cookieyes} from "./cmps/cookieyes.mjs"
import {fazCookieManager} from "./cmps/faz-cookie-manager.mjs"
import {iubenda} from "./cmps/iubenda.mjs"
import {mooveCookieCompliance} from "./cmps/moove-cookie-compliance.mjs"
import {onetrust} from "./cmps/onetrust.mjs"
import {termly} from "./cmps/termly.mjs"
import {usercentrics} from "./cmps/usercentrics.mjs"
import {wpAutoTerms} from "./cmps/wp-auto-terms.mjs"
import {wpConsentApi} from "./cmps/wp-consent-api.mjs"
import {wpCookieConsent} from "./cmps/wp-cookie-consent.mjs"

export default [
	{...beautifulCookieConsent, name: "Beautiful Cookie Consent"},
	{...complianz, name: "Complianz"},
	{...cookieCompliance, name: "Cookie Compliance (hu-manity.co)"},
	{...cookieConfirm, name: "Cookie Confirm"},
	{...cookieScript, name: "Cookie Script"},
	{...cookiebot, name: "Cookiebot"},
	{...cookiefirst, name: "Cookiefirst"},
	{...cookieyes, name: "CookieYes"},
	{...fazCookieManager, name: "FAZ Cookie Manager"},
	{...iubenda, name: "Iubenda"},
	{...mooveCookieCompliance, name: "GDPR Cookie Compliance (Moove Agency)"},
	{...onetrust, name: "OneTrust"},
	{...termly, name: "Termly"},
	{...usercentrics, name: "Usercentrics"},
	{...wpAutoTerms, name: "WP AutoTerms"},
	{...wpConsentApi, name: "WP Consent API"},
	{...wpCookieConsent, name: "WP Cookie Consent"},
]
